import "react-app-polyfill/ie9";
import "promise-polyfill/src/polyfill";
import "core-js/fn/array/find";
import "core-js/fn/array/find-index";
import "core-js/fn/array/includes";
import "core-js/fn/string/includes";
import "core-js/fn/string/ends-with";
import "core-js/fn/object/assign";
import "core-js/es7/object";
import "core-js/es6/map";
import "core-js/es6/set";
import "es6-promise/auto";
import "fetch-polyfill";

import "./index.css";

import React from "react";
import ReactDOM from "react-dom";
import Router from "./components/router";
import Footer from "./components/footer";

const App = () => (
  <>
    <Router />
    <Footer />
  </>
);

ReactDOM.render(<App />, document.querySelector("#root"));
